import React, { memo, useState } from 'react'
import { IModalAction, TextField } from 'transfix-ui/components'
import { FormModal } from 'transfix-ui/components/Modals'
import { Typography } from 'transfix-ui/core'

interface IImpersonateUserDialogProps {
  showImpersonateDialogForUserId: number | null
  impersonating?: boolean
  impersonateError: string
  hideImpersonateUserDialog: () => void
  impersonateParentUser: (reasonValue: string) => void
}

export const ImpersonateUserDialog = memo<IImpersonateUserDialogProps>(
  ({
    hideImpersonateUserDialog,
    impersonateError,
    impersonateParentUser,
    impersonating = false,
    showImpersonateDialogForUserId,
  }) => {
    const [reasonValue, setReasonValue] = useState<string>('')
    const [emptyReasonError, setEmptyReasonError] = useState<string | undefined>(undefined)
    const onChangeReasonValue = (impersonationReason: string) => {
      setEmptyReasonError(undefined)
      setReasonValue(impersonationReason)
    }
    const cancelHandler = () => {
      setEmptyReasonError(undefined)
      hideImpersonateUserDialog()
    }
    const impersonateHandler = () => {
      if (!reasonValue) {
        setEmptyReasonError('Impersonation reason needed.')
        return
      }
      impersonateParentUser(reasonValue)
    }
    const impersonateActions = [
      {
        label: 'Cancel',
        type: 'dismiss',
        disabled: impersonating,
        dataTest: 'impersonate-cancel',
      },
      {
        label: 'Continue',
        type: 'confirm',
        action: impersonateHandler,
        disabled: impersonating,
        dataTest: 'impersonate-continue',
      },
    ] as IModalAction[]

    return (
      <FormModal
        title='Impersonate User'
        size={4}
        onClose={cancelHandler}
        open={!!showImpersonateDialogForUserId}
        actions={impersonateActions}>
        <Typography className='mb4'>Please tell us why you are impersonating this user.</Typography>
        <TextField
          id='reason'
          data-test='reason'
          label='Reason'
          value={reasonValue || ''}
          onChange={event => onChangeReasonValue(event.target.value)}
          error={!!emptyReasonError || !!impersonateError}
          validationMessage={emptyReasonError || impersonateError}
        />
      </FormModal>
    )
  }
)
